import type { SVGProps } from 'react'

export function FluentBug16Regular(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      role="img"
      aria-label="icon"
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      {/* Icon from Fluent UI System Icons by Microsoft Corporation - https://github.com/microsoft/fluentui-system-icons/blob/main/LICENSE */}
      <path
        fill="currentColor"
        d="M7.3 1.5a.5.5 0 0 0-1 0v.8c0 .289.072.561.2.8a2.5 2.5 0 0 0-1.74 1.846A1.1 1.1 0 0 1 4 3.9V2.5a.5.5 0 0 0-1 0v1.4a2.1 2.1 0 0 0 1.7 2.062V7H2.5a.5.5 0 0 0 0 1h2.2v1.7q0 .162.015.32A2 2 0 0 0 3 12v1.5a.5.5 0 0 0 1 0V12a1 1 0 0 1 .966-1a3.3 3.3 0 0 0 6.068 0A1 1 0 0 1 12 12v1.5a.5.5 0 0 0 1 0V12a2 2 0 0 0-1.715-1.98a3 3 0 0 0 .015-.32V8h2.2a.5.5 0 0 0 0-1h-2.2V5.962A2.1 2.1 0 0 0 13 3.9V2.5a.5.5 0 0 0-1 0v1.4c0 .49-.32.904-.761 1.047A2.5 2.5 0 0 0 9.5 3.1a1.7 1.7 0 0 0 .199-.8v-.8a.5.5 0 0 0-1 0v.8a.7.7 0 1 1-1.4 0zm-1.6 6V5.491A1.5 1.5 0 0 1 7.2 4h1.6a1.5 1.5 0 0 1 1.5 1.5v4.2a2.3 2.3 0 0 1-4.6 0z"
      />
    </svg>
  )
}
